
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 44.834"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M34.488 6.567l-4.961-5.008A5.073 5.073 0 0025.89.047L5.15 0a5 5 0 00-3.638 1.512A5.073 5.073 0 000 5.15v34.535a5.162 5.162 0 005.15 5.15h25.7a5.162 5.162 0 005.15-5.15V10.2a5 5 0 00-1.512-3.633zm-1.977 1.391a3.036 3.036 0 01.71 1.168h-5.633a.659.659 0 01-.668-.668V2.826a3.38 3.38 0 011.168.71zM30.19 42.115H5.81a3.29 3.29 0 01-3.272-3.272V6.038a3.407 3.407 0 01.941-2.331 3.143 3.143 0 012.331-.941l19.09.045v6.23a2.343 2.343 0 002.331 2.331h6.23V38.8a3.3 3.3 0 01-3.271 3.315z"}}),_c('path',{staticClass:"a",attrs:{"d":"M28.251 25.569H16.629c-.472 0-.85.521-.85 1.171s.378 1.171.85 1.171h11.622c.472 0 .85-.521.85-1.171.001-.586-.377-1.171-.85-1.171zM28.251 16.97H16.629c-.472 0-.85.521-.85 1.171s.378 1.171.85 1.171h11.622c.472 0 .85-.521.85-1.171s-.377-1.171-.85-1.171zM28.251 33.893H16.629c-.472 0-.85.521-.85 1.172s.378 1.171.85 1.171h11.622c.472 0 .85-.521.85-1.171s-.377-1.172-.85-1.172zM12.636 13.984L9.35 17.27l-1.239-1.293a.99.99 0 00-1.4 1.4l1.993 1.993a.893.893 0 00.7.269 1.134 1.134 0 00.7-.269l3.986-3.986a1.008 1.008 0 000-1.4 1.076 1.076 0 00-1.454 0zM12.635 23.841l-3.286 3.286-1.293-1.293a.99.99 0 10-1.4 1.4l1.993 1.993a.893.893 0 00.7.269 1.134 1.134 0 00.7-.269l3.986-3.986a.99.99 0 00-1.4-1.4zM12.635 33.645l-3.286 3.286-1.293-1.293a.99.99 0 10-1.4 1.4l1.993 1.993a.893.893 0 00.7.269 1.134 1.134 0 00.7-.269l3.987-3.986a.99.99 0 10-1.4-1.4z"}})])
          )
        }
      }
    